import { createApp } from 'vue'
import dayjs from 'dayjs'
import i18n from './i18n'
import { createVuestic } from 'vuestic-ui'

import stores from './stores'
import router from './router'
import vuesticGlobalConfig from './services/vuestic-ui/global-config'
import App from './App.vue'
import $axios from './injects/axios'
import { useUserStore } from './stores/user-store'
import $common from './injects/common'
import $formDatas from './injects/formDatas'

const tokenName = import.meta.env.VITE_APP_TOKEN_NAME

const app = createApp(App)
app.config.globalProperties.$dayjs = dayjs
app.config.errorHandler = (err, _vm, info) => {
  // Global error handler
  try {
    // 에러 무한루프 방지
    console.error(err)
    // console.error('errorHandler vm', _vm)
    console.error('errorHandler info:', info)
  } catch (e) {
    console.error('errorHandler error:', e)
  }
}

app.provide('$axios', $axios)
app.provide('$dayjs', dayjs)
app.provide('$common', $common)
app.provide('$formDatas', $formDatas)

app.use(stores)
app.use(router)
app.use(i18n)
app.use(createVuestic({ config: vuesticGlobalConfig }))

// if (!localStorage.getItem('theme')) {
//   localStorage.setItem('theme', 'dark')
// }
;(async () => {
  if (localStorage.getItem(tokenName)) {
    const store = useUserStore()
    await store.getLogin()
  }

  app.mount('#app')
})()
